module.exports = __webpack_public_path__ + "img/panjabiSizeChart.a04ce835.png";